import React from 'react';
import { FieldLabel, FieldMessage, useFieldSemantics } from './fieldSemantics';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, helperText, className = '', id, 'aria-describedby': ariaDescribedBy, 'aria-invalid': ariaInvalid, ...props }, ref) => {
    const field = useFieldSemantics({
      id,
      error,
      helperText,
      'aria-describedby': ariaDescribedBy,
      'aria-invalid': ariaInvalid,
    });
    const textareaId = field.fieldId;

    return (
      <div className="w-full">
        {label && <FieldLabel htmlFor={textareaId}>{label}</FieldLabel>}
        <textarea
          ref={ref}
          id={textareaId}
          className={`
            block w-full px-3 py-2 border rounded-md bg-slate-900 text-white
            placeholder-slate-500
            focus:outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500
            disabled:bg-slate-800/50 disabled:cursor-not-allowed
            ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-slate-700'}
            ${className}
          `}
          {...props}
          {...field.controlProps}
        />
        <FieldMessage field={field} />
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
